export const environment = {
   app: {
    version: "2.2.1"
  },
  environmentName: 'development',
  urlBase: 'https://dev.sihc.hamelconstruction.com/',
  apiBaseUrl: 'https://dev.sihc.hamelconstruction.com/SIHC.Services/api/v1/',
  apiDocumentUrl: 'https://dev.sihc.hamelconstruction.com/SIHC.Services/doc/',
  apiRapportsBaseUrl: 'https://dev.sihc.hamelconstruction.com/SIHC.Rapports/api/v1/',
  viewRapportsBaseUrl: 'https://dev.sihc.hamelconstruction.com/SIHC.Rapports/api/v1/document/',
  production: false,
  mecanique: false,
  auth0: {
    urlGestionUtilisateurs: "https://manage.auth0.com/dashboard/us/dev-u2uzb8h1/users",
    token_url: "https://dev-u2uzb8h1.us.auth0.com/oauth/token",
    roles_url: "https://dev-u2uzb8h1.us.auth0.com/api/v2/users/{userId}/roles",
    client_id: "aScgbgzY7TMDgu8jUMcTFb622r1B2lmz",
    client_secret: "Dgne3Z3lXVLn8FKtBmIocGSvlu3maF4wUBlQngAAO0VBQNxraDKcREuK0aKUs9eI",
    audience: "https://dev-u2uzb8h1.us.auth0.com/api/v2/",
    grant_type: "client_credentials"
  },
  auth: {
    domain: "dev-u2uzb8h1.us.auth0.com",
    clientId: "kuNaieyC72OZWsiaSKj9QYWGq84HyhhP",
    authorizationParams: {
      redirect_uri: window.location.origin,  
      audience: "https://dev.sihc.hamelconstruction.com/SIHC.Services/api/v1/"
    },
  },
  dev: {
    serverUrl: "https://dev.sihc.hamelconstruction.com/SIHC.Services/api/v1/"
  },
  parametres: {
    garanties: {
      seuilRouge: 15,
      seuilJaune: 60
    }
  },
  mapbox: {
    accessToken: "pk.eyJ1IjoiYWRtaW5oYyIsImEiOiJjbHVsajJjaGUwbWtnMmptd2x1dmlkaGo5In0.DkAfDE0s-XtPHwPMofPo7Q"
  },
  cloudflare: {
    url: "https://dev.sihc.hamelconstruction.com/blob/"
  },
  rapportSst: {
    niveauNonConformite: 0
  },
  turnstileSiteKey: '0x4AAAAAAByZm9qAXFJ_CUrP',
  supabase: {
    url: "https://jffruqurbzovtrsinzvo.supabase.co",
    anonKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpmZnJ1cXVyYnpvdnRyc2luenZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTczNDcwNTMsImV4cCI6MjA3MjkyMzA1M30.orjCeQxObDf2lR7VPyJLgdAiFUbGhQEi4_JvesbQD0o",
    providerId: "cc64c247-d562-4210-806b-c369840c0f66"
  },
  vapidPublicKey: 'BNlmGwyVoU0b-r3fBPT1cvd8Cw36OumR515nkRHfD5XCRBfJ3FLBu_f_xv2I202N60L63O84jN1kVaBBevd2Aic'
};